import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  collateral_cash: {
    name: 'Value of collateral posted in the form of cash and cash equivalents',
    order: 190,
    letter: 'A'
  },
  collateral_securities: {
    name: 'Value of collateral posted in the form of other securities',
    order: 191,
    letter: 'A'
  },
  other_collateral_posted: {
    name: 'Value of other collateral and credit support posted (including face amount of letters of credit and similar third party credit support)',
    order: 192,
    letter: 'A'
  }
};
export function ValueOfCollateral({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.ALL_COUNTERPARTY_COLLATERAL,
    onChangeFund,
    schema: schema.ALL_COUNTERPARTY_COLLATERAL,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.ALL_COUNTERPARTY_COLLATERAL?.field_names || [],
    tableName: 'ALL_COUNTERPARTY_COLLATERAL',
    columnLables,
    isMultiFunds,
    funds
  });

  return (
    <Table
      id="fca-reporttables-value-of-collateral-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
